import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {generateBorder} from '#core/application/modules/tiles/border/index.js';
import {generateSecondaryLink} from '#core/application/modules/tiles/link/index.js';

import SEARCH_RESULT from './search-result.palette-schema.yaml';

registerTileSchema(SEARCH_RESULT);

export function generateRecentSearch(TILE) {
    return {
        text: {
            style: {
                ...TILE.SEARCH_RECENT_ITEMS_TITLE_TEXT,
            },
        },
        item: {
            style: {
                ...resolveBackground(TILE.SEARCH_RECENT_ITEM_BG),
                ...generateBorder(TILE.SEARCH_RECENT_ITEM_BORDER),
            },
        },
        itemText: {
            style: {
                ...TILE.SEARCH_RECENT_ITEM_TEXT,
            },
        },
        removeIcon: {
            style: TILE.SEARCH_RECENT_ITEM_REMOVE_ICON_COLOR ? {fill: TILE.SEARCH_RECENT_ITEM_REMOVE_ICON_COLOR} : {},
        },
    };
}

export function generateSearchResultItem(TILE) {
    const SEARCH_RESULT_ITEM_STATUS_BASE_TEXT = {
        ...TILE.SEARCH_RESULT_ITEM_STATUS_TEXT,
    };
    const SEARCH_RESULT_ITEM_NAME_TEXT_STYLES = {
        ...TILE.SEARCH_RESULT_ITEM_NAME_TEXT,
    };

    return {
        searchNamesContainer: {
            itemSpacing: 0,
        },
        infoContainer: {
            itemSpacing: 2,
        },
        button: {
            style: {
                base: {
                    padding: '8px 16px',
                },
            },
        },
        sportIcon: {
            icon: {
                container: {
                    style: {
                        flexBasis: '32px',
                        padding: '5px 8px 5px 0',
                    },
                },
                style: {
                    fill: TILE.SEARCH_RESULT_ITEM_ICON_COLOR,
                },
            },
        },
        parentText: {
            style: {
                ...TILE.SEARCH_RESULT_ITEM_TOURNAMENT_TEXT,
            },
        },
        sportNameText: {
            style: SEARCH_RESULT_ITEM_NAME_TEXT_STYLES,
        },
        nameText: {
            style: SEARCH_RESULT_ITEM_NAME_TEXT_STYLES,
        },
        live: {
            style: SEARCH_RESULT_ITEM_STATUS_BASE_TEXT,
        },
        startDate: {
            style: SEARCH_RESULT_ITEM_STATUS_BASE_TEXT,
        },
        startTime: {
            style: SEARCH_RESULT_ITEM_STATUS_BASE_TEXT,
        },
    };
}

export function generateSearchResultGroup(TILE) {
    return {
        title: {
            style: {
                ...TILE.SEARCH_RESULTS_GROUP_TITLE_TEXT,
            },
        },
        showMoreButton: {
            button: generateSecondaryLink(TILE.SEARCH_RESULTS_GROUP_SHOW_MORE_BUTTON),
            buttonIcon: icon(TILE.SEARCH_RESULTS_GROUP_SHOW_MORE_BUTTON.SECONDARY_LINK_ICON_COLOR),
        },
    };
}
